import { ControlValueAccessor } from '@angular/forms';

export abstract class BaseControl<T> implements ControlValueAccessor {

    value!: T;
    disabled = false;

    onChange = (_: T) => { };
    onTouched = () => { };

    constructor() {}

    writeValue(value: T): void {
        this.value = value;
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }
}
